import Icon from "@amzn/meridian/esm/components/icon";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import alertTokens from "@amzn/meridian-tokens/base/icon/alert";
import LearnMoreLink from "../../components/LearnMoreLink";
import WaveformLayout from "./WaveformLayout";

const AimsNotAvailable = ({ aimsNotAvailableMessage }) => {
  return (
    <WaveformLayout icon={<Icon tokens={alertTokens} color="warning" />}>
      <Text type="h50" color="secondary">Inform attendees if needed</Text>
      <Row height="16px"/>
      <Text type="b200" color="secondary">
        {aimsNotAvailableMessage}
      </Text>
      <Row height="16px"/>
      <LearnMoreLink />
    </WaveformLayout>
  );
};

export default AimsNotAvailable;
